import React, { useEffect, useRef } from 'react';

import { RedirectMessage } from '../Authentication';
import { IntercomHelpUrl, IntercomAppId } from '../../configuration';

export const getCookieByKey = (key: string): string =>
  document.cookie.split('; ').reduce((total, currentCookie) => {
    const [storedKey, storedValue] = currentCookie.split('=');
    return key === storedKey ? decodeURIComponent(storedValue) : total;
  }, '');

const IntercomRedirect = (): JSX.Element => {
  const interval: React.MutableRefObject<NodeJS.Timeout | undefined> = useRef();

  useEffect(() => {
    interval.current = setInterval(() => {
      const cookie = getCookieByKey(`intercom-session-${IntercomAppId}`);
      if (cookie) {
        window.location.assign(IntercomHelpUrl);
      }
    }, 1000);
    return () => {
      if (interval.current) {
        clearInterval(interval.current);
      }
    };
  }, []);

  return <RedirectMessage />;
};

export default IntercomRedirect;
